// extracted by mini-css-extract-plugin
export var caption = "bM_hv";
export var grey = "bM_dK";
export var heading = "bM_G";
export var image = "bM_d";
export var left = "bM_bS";
export var reverse = "bM_dG";
export var right = "bM_bV";
export var section = "bM_b";
export var video = "bM_gT";
export var videoContainer = "bM_ck";
export var videoWrapper = "bM_cl";